import useErrorNotify from './useErrorNotify';

export default useErrorNotify;
